import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.3);
    border-radius: 8px;
    padding: 16px;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    background-color: ${({theme}) => theme.colors.interfacePure0};

    .label {
        font-size: 12px;
        color: ${({theme}) => theme.colors.interfaceGray500};
        font-weight: 500;
    }

    .parte {
        display: grid;
        grid-template-columns: 40px 1fr 32px;
        align-items: center;
        gap: 10px;
        background-color: var(--parte-card-bg);
        padding: 10px 20px 10px 10px;
        margin-top: 10px;
        border-radius: 8px;

        .iconc {
            background-color: ${({theme}) => theme.colors.interfacePure0};
            width: 35px;
            height: 35px;
            border-radius: 8px;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .info {
            display: flex;
            flex-direction: column;
            gap: 2px;

            .nome {
                font-size: 14px;
                font-weight: bolder;
                color: ${({theme}) => theme.colors.interfaceText500};
            }

            .codigo {
                font-size: 10px;
                font-weight: 400;
                color: ${({theme}) => theme.colors.interfaceText500};
            }
        }

        .button {
            height: 35px;
            width: 35px;
            border-radius: 8px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            transition: all .3s;
            &:hover {
                background-color: ${({theme}) => theme.colors.interfacePure100};
            }
        }   
    }

    .parte-vazio {
        font-size: 0.875rem;
        color: ${(props: any) => props.theme.colors.c718096};
        font-style: italic;
        padding: 14px 20px;
        text-align: center;
        background-color: ${(props: any) => props.theme.colors.cf3f7fb};
        border-radius: 8px;
        border: 1px dashed ${(props: any) => props.theme.colors.ccbd5e0};
        margin-top: 12px;
    }
    
`

